module.exports = __webpack_public_path__ + "static/media/landing-banner.f8b47f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Main/images/landing-banner.png
// module id = 965
// module chunks = 0